import React from 'react'

// Icons
import bulb from "../../../../assets/icons/bulb.svg";

// Styles
import './ReminderCount.scss';

const ReminderCount = ({reminders}) => {
  return reminders && reminders.length !== 0 ? (
    <div className='reminder-count'>
      <span>{reminders.length}</span>
      <img src={bulb} alt="bulb" className="img-fluid" />
    </div>
  ) : null
}

export default ReminderCount